import { useLocation } from 'react-router-dom';

/**
 * Paths where the mobile navigation header should be hidden
 * because the page provides its own mobile header/navigation.
 */
const HIDE_MOBILE_HEADER_PATHS = ['/conversations/'];

/**
 * Paths that override HIDE_MOBILE_HEADER_PATHS — the mobile header
 * is shown even if a parent hide-path matches.
 */
const SHOW_MOBILE_HEADER_PATHS = ['/conversations/history'];

/**
 * Determines whether the mobile navigation header should be visible
 * for the current route. Used by both the sidebar (to render/hide the
 * header) and DashboardLayout (to apply/remove top padding).
 */
export function useMobileNavHeader(): { showMobileHeader: boolean } {
  const location = useLocation();

  const isHiddenPath = HIDE_MOBILE_HEADER_PATHS.some(path =>
    location.pathname.includes(path)
  );
  const isShowOverride = SHOW_MOBILE_HEADER_PATHS.some(path =>
    location.pathname.includes(path)
  );

  const showMobileHeader = !isHiddenPath || isShowOverride;

  return { showMobileHeader };
}
